import { createRouter, createWebHistory } from "vue-router";

import store from "../store";
const routes = [
	{
		path: '/',
		name: 'Dashboard',
		icon: 'FolderWithStar',
		component: () => import(/* webpackChunkName: "about" */ '../views/Dashboard.vue'),
		meta: { layout: 'Dashboard', requiresAuth: true }
	},
	{
		path: '/new',
		name: 'new',
		default: () => import(/* webpackChunkName: "about" */ '../views/NewWindow.vue'),
		component: () => import(/* webpackChunkName: "about" */ '../views/NewWindow.vue'),
		props: true,
		meta: { layout: 'Default' }
	},
	{
		path: '/create',
		name: 'module',
		component: () => import(/* webpackChunkName: "about" */ '../components/core/create/create.vue')
	},
	{
		path: '/login',
		name: 'login',
		component: () => import(/* webpackChunkName: "about" */ '../views/public/Login.vue')
	},
	{
		path: '/signup',
		name: 'signup',
		component: () => import(/* webpackChunkName: "about" */ '../views/public/Signup.vue')
	},
	{
		path: '/accounting/:tab_id',
		name: 'accounting',
		icon: 'Calculator',
		component: () => import(/* webpackChunkName: "about" */ '../views/Dashboard.vue'),
		meta: { layout: 'Dashboard', requiresAuth: true }
	},
	{
		path: '/assets/:tab_id',
		name: 'Assets',
		icon: 'Briefcase',
		component: () => import(/* webpackChunkName: "about" */ '../views/Dashboard.vue'),
		meta: { layout: 'Dashboard', requiresAuth: true }
	},
	{
		path: '/billing/:tab_id',
		name: 'Billing',
		icon: 'Checkbook',
		component: () => import(/* webpackChunkName: "about" */ '../views/Dashboard.vue'),
		meta: { requiresAuth: true }
	},
	{
		path: '/calendar',
		name: 'Calendar',
		icon: 'Calendar',
		component: () => import(/* webpackChunkName: "about" */ '../views/Calendar.vue'),
		meta: { layout: 'Dashboard', requiresAuth: true }
	},
	{
		path: '/crm/:tab_id',
		name: 'CRM',
		icon: 'GraphMoney',
		component: () => import(/* webpackChunkName: "about" */ '../views/Dashboard.vue'),
		meta: { requiresAuth: true }
	},
	{
		path: '/file/:tab_id',
		name: 'Files',
		icon: 'FolderWithFolders',
		component: () => import(/* webpackChunkName: "about" */ '../views/Dashboard.vue'),
		meta: { layout: 'Dashboard', requiresAuth: true }
	},
	{
		path: '/jobs/:tab_id',
		name: 'Jobs',
		icon: 'FolderWithUser',
		component: () => import(/* webpackChunkName: "about" */ '../views/Dashboard.vue'),
		meta: { layout: 'Dashboard', requiresAuth: true }
	},
	{
		path: '/messages/:tab_id',
		name: 'Messages',
		icon: 'Comment',
		component: () => import(/* webpackChunkName: "about" */ '../views/Dashboard.vue'),
		meta: { layout: 'Dashboard', requiresAuth: true }
	},
	{
		path: '/planner',
		name: 'Planner',
		icon: 'Box',
		component: () => import(/* webpackChunkName: "about" */ '../views/ProjectManager.vue'),
		meta: { layout: 'Dashboard', requiresAuth: true }
	},
	{
		path: '/payables/:tab_id',
		name: 'Payables',
		icon: 'CalculatorWithFolder',
		component: () => import(/* webpackChunkName: "about" */ '../views/Dashboard.vue'),
		meta: { layout: 'Dashboard', requiresAuth: true }
	},
	{
		path: '/payroll/:tab_id',
		name: 'Payroll',
		icon: 'FileWithTextAndFont',
		component: () => import(/* webpackChunkName: "about" */ '../views/Dashboard.vue'),
		meta: { layout: 'Dashboard', requiresAuth: true }
	},
	{
		path: '/reports/:tab_id',
		name: 'Reports',
		icon: 'Chart',
		component: () => import(/* webpackChunkName: "about" */ '../views/Dashboard.vue'),
		meta: { layout: 'Dashboard', requiresAuth: true }
	},
	{
		path: '/time/:tab_id',
		name: 'Time',
		icon: 'Alarm',
		component: () => import(/* webpackChunkName: "about" */ '../views/Dashboard.vue'),
		meta: { layout: 'Dashboard', requiresAuth: true }
	},
	{
		path: '/tools/:tab_id',
		name: 'Tools',
		icon: 'Gear',
		component: () => import(/* webpackChunkName: "about" */ '../views/Dashboard.vue'),
		meta: { layout: 'Dashboard', requiresAuth: true }
	},
	{
		path: '/events/:id?',
		name: 'Tools',
		icon: 'Gear',
		component: () => import(/* webpackChunkName: "about" */ '../views/Event.vue'),
		meta: { layout: 'Default', requiresAuth: false }
	},

	{
		path: '/event/:id?',
		name: 'File',
		icon: 'Gear',
		component: () => import(/* webpackChunkName: "about" */ '../views/Files.vue'),
		meta: { layout: 'Dashboard', requiresAuth: false }
	},
	{
		path: '/file/:id?',
		name: 'File',
		icon: 'Gear',
		component: () => import(/* webpackChunkName: "about" */ '../views/Files.vue'),
		meta: { layout: 'Dashboard', requiresAuth: true }
	}
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
router.beforeEach((to, from, next) => {
  let auth = store.state.auth;

  // Not logged into a guarded route?
  if (to.meta.requiresAuth === true && !auth.status.loggedIn && !auth.user) {
    next({ name: "login" });
  }

  // Logged in for an auth route
  else if (
    (to.name == "login" || to.name == "register") &&
    auth.status.loggedIn &&
    auth.user
  ) {
    next({ name: "dashboard" });
  }

  // Carry On...
  else next();
});
export default router;
